<template>
  <div>
    <div class="e-loader-back" v-if="loading">
      <div class="e-loader-content">
        <div class="ball-clip-rotate-multiple">
          <div></div>
          <div></div>
        </div>
        <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
      </div>
    </div>
    <h4
      class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4"
    >
      <div class="e-mtavr-15">შავი სიის პარამეტრები</div>
    </h4>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-xs-12 col-lg-12">
        <b-tabs class="nav-tabs-top nav-responsive-xl">
          <b-tab class="e-nusx-8" @click="JuridicalStatus = 1">
            <template #title>
              <span class="e-nusx-8"> ფიზიკური პირი </span>
            </template>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <b-card
                    bg-variant="transparent"
                    border-variant="secondary"
                    class="shadow-none mb-4"
                  >
                    <div class="card-title with-elements">
                      <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                        აირჩიე შედარების ალგორითმი
                        <strong class="text-danger">ფიზიკური პირის</strong>
                        შემთხვევაში
                      </h5>
                    </div>
                    <label class="switcher switcher-square">
                      <input
                        type="checkbox"
                        v-model="BL_ParamsItem_PP.amlParameter.logic1"
                        class="switcher-input"
                      />
                      <span class="switcher-indicator">
                        <span class="switcher-yes">
                          <span class="lnr lnr-checkmark-circle"></span>
                        </span>
                        <span class="switcher-no">
                          <span class="lnr lnr-cross-circle"></span>
                        </span>
                      </span>
                      <span class="switcher-label e-nusx-8">
                        მოთხოვნის შედარება მოხდეს
                        <strong>სახელით</strong>, <strong>გვარით</strong> და
                        <strong>პირადი N</strong>
                      </span>
                    </label>
                    <hr class="border-light mt-3" />
                    <label class="switcher switcher-square">
                      <input
                        type="checkbox"
                        v-model="BL_ParamsItem_PP.amlParameter.logic2"
                        class="switcher-input"
                      />
                      <span class="switcher-indicator">
                        <span class="switcher-yes">
                          <span class="lnr lnr-checkmark-circle"></span>
                        </span>
                        <span class="switcher-no">
                          <span class="lnr lnr-cross-circle"></span>
                        </span>
                      </span>
                      <span class="switcher-label e-nusx-8">
                        მოთხოვნის შედარება მოხდეს
                        <strong>სახელით</strong>, <strong>გვარით</strong> და
                        <strong>დაბადების თარიღით</strong>
                      </span>
                    </label>
                    <hr class="border-light mt-3" />
                    <label class="switcher switcher-square">
                      <input
                        type="checkbox"
                        v-model="BL_ParamsItem_PP.amlParameter.logic3"
                        class="switcher-input"
                      />
                      <span class="switcher-indicator">
                        <span class="switcher-yes">
                          <span class="lnr lnr-checkmark-circle"></span>
                        </span>
                        <span class="switcher-no">
                          <span class="lnr lnr-cross-circle"></span>
                        </span>
                      </span>
                      <span class="switcher-label e-nusx-8">
                        მოთხოვნის შედარება მოხდეს
                        <strong>სახელით</strong> და
                        <strong>გვარით</strong>
                      </span>
                    </label>
                    <hr class="border-light mt-3" />
                  </b-card>
                  <i class="badge badge-danger mb-1" v-if="individualErrorMsg"
                    >შეცდომა</i
                  ><span class="e-nusx-8" v-if="individualErrorMsg">
                    <small>
                      გთხოვთ აირჩიოთ შედარების ალგორითმი
                      <span class="text-danger">ფიზიკური პირის</span>
                      შემთხვევაში</small
                    >
                  </span>
                  <b-form-group>
                    <button
                      class="btn btn-primary mt-3"
                      @click="saveBLSettings"
                    >
                      შენახვა
                    </button>
                    <button class="btn btn-secondary mt-3" @click="clearForm">
                      გასუფთავება
                    </button>
                  </b-form-group>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <b-card
                    bg-variant="transparent"
                    border-variant="secondary"
                    class="shadow-none mb-4"
                  >
                    <div class="card-title with-elements">
                      <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                        მოქმედი შედარების ალგორითმი
                        <strong class="text-danger">ფიზიკური პირის</strong>
                        შემთხვევაში
                      </h5>
                    </div>
                    <div
                      class="callout callout-warning"
                      v-if="
                        !BL_ParamsItem_PP.amlParameter.logic1 &&
                        !BL_ParamsItem_PP.amlParameter.logic2 &&
                        !BL_ParamsItem_PP.amlParameter.logic3
                      "
                    >
                      <h5 class="e-mtavr-17">ყურადღება!</h5>
                      <p class="e-nusx-8">
                        ამ დროისათვის სისტემაში არ მოქმედებს მოთხოვნის შავ
                        სიასთან შედარების არცერთი ლოგიკა.
                      </p>
                      <hr />
                      <p class="e-nusx-8">
                        გთხოვთ ყურადღებით აირჩიოთ თქვენთვის მისაღები ლოგიკა ერთი
                        ან რამოდენიმე
                      </p>
                    </div>
                    <div class="callout callout-success" v-else>
                      <h5 class="e-mtavr-17">
                        არჩევანის შესაბამისად მოთხოვნა შავ სიასთან შედარდება
                        შემდეგი ლოგიკით
                      </h5>
                      <p
                        class="e-nusx-8"
                        v-if="BL_ParamsItem_PP.amlParameter.logic1"
                      >
                        <strong>ლოგიკა 1</strong> - მოთხოვნის პარამეტრები
                        შედარდება შავი სიის ჩანაწერის სახელს, გვარს და პირად
                        ნომერს.
                      </p>
                      <hr v-if="BL_ParamsItem_PP.amlParameter.logic1" />
                      <p
                        class="e-nusx-8"
                        v-if="
                          BL_ParamsItem_PP.amlParameter.logic1 &&
                          (BL_ParamsItem_PP.amlParameter.logic2 ||
                            BL_ParamsItem_PP.amlParameter.logic3)
                        "
                      >
                        <span class="badge badge-warning">ყურადღება</span> -
                        <strong> ლოგიკა 1</strong>-ით ვერცერთი დამთხვევის
                        გამოვლენისას ამოქმედდება შემდეგი ლოგიკა
                      </p>
                      <hr
                        v-if="
                          BL_ParamsItem_PP.amlParameter.logic1 &&
                          (BL_ParamsItem_PP.amlParameter.logic2 ||
                            BL_ParamsItem_PP.amlParameter.logic3)
                        "
                      />
                      <p
                        class="e-nusx-8"
                        v-if="BL_ParamsItem_PP.amlParameter.logic2"
                      >
                        <strong>ლოგიკა 2</strong> - მოთხოვნის პარამეტრები
                        შედარდება შავი სიის ჩანაწერის სახელს, გვარს და დაბადების თარიღით
                      </p>
                      <hr v-if="BL_ParamsItem_PP.amlParameter.logic2" />
                      <p
                        class="e-nusx-8"
                        v-if="
                          BL_ParamsItem_PP.amlParameter.logic2 &&
                          BL_ParamsItem_PP.amlParameter.logic3
                        "
                      >
                        <span class="badge badge-warning">ყურადღება</span> -
                        <strong> ლოგიკა 2</strong>-ით ვერცერთი დამთხვევის
                        გამოვლენისას ამოქმედდება შემდეგი ლოგიკა
                      </p>
                      <hr
                        v-if="
                          BL_ParamsItem_PP.amlParameter.logic2 &&
                          BL_ParamsItem_PP.amlParameter.logic3
                        "
                      />
                      <p
                        class="e-nusx-8"
                        v-if="BL_ParamsItem_PP.amlParameter.logic3"
                      >
                        <strong>ლოგიკა 3</strong> - მოთხოვნის პარამეტრები
                        შედარდება შავი სიის ჩანაწერის სახელს და გვარს.
                      </p>
                      <hr v-if="individual.logic3" />
                      <p class="e-nusx-8">
                        <strong
                          >შერჩეული ლოგიკით პირდაპირი დამთხვევის შემთხვევაში
                          შემოსული მოთხოვნა ავტომატურად დაიბლოკება.</strong
                        >
                      </p>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab class="e-nusx-8" @click="JuridicalStatus = 2">
            <template #title>
              <span class="e-nusx-8"> იურიდიული პირი </span>
            </template>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <b-card
                    bg-variant="transparent"
                    border-variant="secondary"
                    class="shadow-none mb-4"
                  >
                    <div class="card-title with-elements">
                      <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                        აირჩიე შედარების ალგორითმი
                        <strong class="text-danger">იურიდიული პირის</strong>
                        შემთხვევაში
                      </h5>
                    </div>
                    <label class="switcher switcher-square">
                      <input
                        type="checkbox"
                        v-model="BL_ParamsItem_LE.amlParameter.logic1"
                        class="switcher-input"
                      />
                      <span class="switcher-indicator">
                        <span class="switcher-yes">
                          <span class="lnr lnr-checkmark-circle"></span>
                        </span>
                        <span class="switcher-no">
                          <span class="lnr lnr-cross-circle"></span>
                        </span>
                      </span>
                      <span class="switcher-label e-nusx-8">
                        მოთხოვნის შედარება მოხდეს
                        <strong>დასახელებით</strong>
                        და
                        <strong>რეზიდენტობით</strong>
                      </span>
                    </label>
                    <hr class="border-light mt-3" />
                    <label class="switcher switcher-square">
                      <input
                        type="checkbox"
                        v-model="BL_ParamsItem_LE.amlParameter.logic2"
                        class="switcher-input"
                      />
                      <span class="switcher-indicator">
                        <span class="switcher-yes">
                          <span class="lnr lnr-checkmark-circle"></span>
                        </span>
                        <span class="switcher-no">
                          <span class="lnr lnr-cross-circle"></span>
                        </span>
                      </span>
                      <span class="switcher-label e-nusx-8">
                        მოთხოვნის შედარება მოხდეს
                        <strong>დასახელებით</strong>
                      </span>
                    </label>
                    <hr class="border-light mt-3" />
                  </b-card>
                  <i class="badge badge-danger" v-if="juridicalErrorMsg"
                    >შეცდომა</i
                  ><span class="e-nusx-8" v-if="juridicalErrorMsg"
                    ><small>
                      გთხოვთ აირჩიოთ შედარების ალგორითმი
                      <span class="text-danger">იურიდიული პირის</span>
                      შემთხვევაში</small
                    ></span
                  >
                  <b-form-group>
                    <button
                      class="btn btn-primary mt-3"
                      @click="saveBLSettings"
                    >
                      შენახვა
                    </button>
                    <button class="btn btn-secondary mt-3" @click="clearForm">
                      გასუფთავება
                    </button>
                  </b-form-group>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <b-card
                    bg-variant="transparent"
                    border-variant="secondary"
                    class="shadow-none mb-4"
                  >
                    <div class="card-title with-elements">
                      <h5 class="m-0 mr-2 text-muted e-mtavr-17 mb-4">
                        მოქმედი შედარების ალგორითმი
                        <strong class="text-danger">იურიდიული პირის</strong>
                        შემთხვევაში
                      </h5>
                    </div>
                    <div
                      class="callout callout-warning"
                      v-if="
                        !BL_ParamsItem_LE.amlParameter.logic1 &&
                        !BL_ParamsItem_LE.amlParameter.logic2
                      "
                    >
                      <h5 class="e-mtavr-17">ყურადღება!</h5>
                      <p class="e-nusx-8">
                        ამ დროისათვის სისტემაში არ მოქმედებს მოთხოვნის შავ
                        სიასთან შედარების არცერთი ლოგიკა.
                      </p>
                      <hr />
                      <p class="e-nusx-8">
                        გთხოვთ ყურადღებით აირჩიოთ თქვენთვის მისაღები ლოგიკა ერთი
                        ან რამოდენიმე
                      </p>
                    </div>
                    <div class="callout callout-success" v-else>
                      <h5 class="e-mtavr-17">
                        არჩევანის შესაბამისად მოთხოვნა შავ სიასთან შედარდება
                        შემდეგი ლოგიკით
                      </h5>
                      <p
                        class="e-nusx-8"
                        v-if="BL_ParamsItem_LE.amlParameter.logic1"
                      >
                        <strong>ლოგიკა 1</strong> - მოთხოვნის პარამეტრები
                        შედარდება შავი სიის ჩანაწერს დასახელებით და რეზიდენტობით.
                      </p>
                      <hr v-if="juridical.logic1" />
                      <p
                        class="e-nusx-8"
                        v-if="
                          BL_ParamsItem_LE.amlParameter.logic1 &&
                          BL_ParamsItem_LE.amlParameter.logic2
                        "
                      >
                        <span class="badge badge-warning">ყურადღება</span> -
                        <strong> ლოგიკა 1</strong>-ით ვერცერთი დამთხვევის
                        გამოვლენისას ამოქმედდება შემდეგი ლოგიკა
                      </p>
                      <hr
                        v-if="
                          BL_ParamsItem_LE.amlParameter.logic1 &&
                          BL_ParamsItem_LE.amlParameter.logic2
                        "
                      />
                      <p
                        class="e-nusx-8"
                        v-if="BL_ParamsItem_LE.amlParameter.logic2"
                      >
                        <strong>ლოგიკა 2</strong> - მოთხოვნის პარამეტრები
                        შედარდება შავი სიის ჩანაწერს დასახელებით.
                      </p>
                      <hr v-if="BL_ParamsItem_LE.amlParameter.logic2" />
                      <p class="e-nusx-8">
                        <strong
                          >შერჩეული ლოგიკით პირდაპირი დამთხვევის შემთხვევაში
                          შემოსული მოთხოვნა ავტომატურად დაიბლოკება.</strong
                        >
                      </p>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
export default {
  data () {
    return {
      saveActionType: '',
      loading: false,
      JuridicalStatus: 1,
      individualErrorMsg: false,
      juridicalErrorMsg: false,
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      individual: {
        logic1: false,
        logic2: false,
        logic3: false
      },
      juridical: {
        logic1: false,
        logic2: false
      },
      BL_ParamsItem_PP: {
        amlParameter: {
          id: 0,
          organisationId: 0,
          juridicalStatusId: 1,
          paramterTypeId: 3,
          parameterTypeName: 'blackList',
          scanningPacketId: 0,
          scanningDatabases: '',
          matchPercent: 0,
          checkInAcuris: true,
          logic1: false,
          logic2: false,
          logic3: false,
          organisationUserId: 0
        },
        scannigPacketDatabases: [
          {
            id: 0,
            name: '',
            description: '',
            scanningPacketID: 0,
            deleteStatus: true
          }
        ]
      },
      // BL_ParamsItem_LE.amlParameter
      BL_ParamsItem_LE: {
        amlParameter: {
          id: 0,
          organisationId: 0,
          juridicalStatusId: 2,
          paramterTypeId: 3,
          parameterTypeName: 'blackList',
          scanningPacketId: 0,
          scanningDatabases: '',
          matchPercent: 0,
          checkInAcuris: true,
          logic1: false,
          logic2: false,
          logic3: false,
          organisationUserId: 0
        },
        scannigPacketDatabases: [
          {
            id: 0,
            name: '',
            description: '',
            scanningPacketID: 0,
            deleteStatus: true
          }
        ]
      }
    }
  },
  created () {
    this.loading = true
    this.loadAmlParameters()
  },
  methods: {
    loadAmlParameters () {
      BaseService.GetAMLParameters(this.header).then((res) => {
        if (res.data.success) {
          if (res.data.result.length > 0) {
            for (var i = 0; i < res.data.result.length; i++) {
              if (
                res.data.result[i].amlParameter.juridicalStatusId === 1 &&
              res.data.result[i].amlParameter.paramterTypeId === 3
              ) {
                this.BL_ParamsItem_PP = res.data.result[i]
              }
              if (
                res.data.result[i].amlParameter.juridicalStatusId === 2 &&
              res.data.result[i].amlParameter.paramterTypeId === 3
              ) {
                this.BL_ParamsItem_LE = res.data.result[i]
              }
            }
          }
          this.loading = false
        }
      })
    },
    saveBLSettings () {
      this.individualErrorMsg = false
      this.juridicalErrorMsg = false
      if (this.JuridicalStatus === 1 &&
        !this.BL_ParamsItem_PP.amlParameter.logic1 &&
        !this.BL_ParamsItem_PP.amlParameter.logic2 &&
        !this.BL_ParamsItem_PP.amlParameter.logic3
      ) {
        this.individualErrorMsg = true
      }
      if (this.JuridicalStatus === 2 && !this.BL_ParamsItem_LE.amlParameter.logic1 && !this.BL_ParamsItem_LE.amlParameter.logic2) {
        this.juridicalErrorMsg = true
      }

      if (!this.individualErrorMsg && !this.juridicalErrorMsg) {
        let param = {}
        if (this.JuridicalStatus === 1) {
          param = this.BL_ParamsItem_PP
          if (param.amlParameter.id > 0) {
            this.saveActionType = 'edit'
          } else {
            this.saveActionType = 'add'
          }
        } else if (this.JuridicalStatus === 2) {
          param = this.BL_ParamsItem_LE
          if (param.amlParameter.id > 0) {
            this.saveActionType = 'edit'
          } else {
            this.saveActionType = 'add'
          }
        }
        if (this.saveActionType === 'add') {
          BaseService.AddAMLParameter(this.header, param)
            .then(res => {
              if (res.data.success) {
                if (this.JuridicalStatus === 1) {
                  this.BL_ParamsItem_PP = res.data.result
                } else if (this.JuridicalStatus === 2) {
                  this.BL_ParamsItem_LE = res.data.result
                }
                this.saveActionType = ''
                this.$swal({
                  icon: 'success',
                  title: 'ინცორმაცია!',
                  html: '<span class="e-nusx-8 e-ts-09rem">მონაცემები დამახსოვრებულია!</span>',
                  showCancelButton: false,
                  confirmButtonColor: '#DD6B55',
                  confirmButtonText: 'გასაგებია',
                  heightAuto: false,
                  keydownListenerCapture: true
                })
              }
            })
        } else if (this.saveActionType === 'edit') {
          BaseService.EditAMLParameter(this.header, param)
            .then(res => {
              if (res.data.success) {
                if (this.JuridicalStatus === 1) {
                  this.BL_ParamsItem_PP = res.data.result
                } else if (this.JuridicalStatus === 2) {
                  this.BL_ParamsItem_LE = res.data.result
                }
                this.saveActionType = ''
                this.$swal({
                  icon: 'success',
                  title: 'ინცორმაცია!',
                  html: '<span class="e-nusx-8 e-ts-09rem">მონაცემები დამახსოვრებულია!</span>',
                  showCancelButton: false,
                  confirmButtonColor: '#DD6B55',
                  confirmButtonText: 'გასაგებია',
                  heightAuto: false,
                  keydownListenerCapture: true
                })
              }
            })
        } else {
          this.$swal({
            icon: 'danger',
            title: 'შეცდომა!',
            html: '<span class="e-nusx-8 e-ts-09rem">მოხდა სისტემური შეცდომა, გთხოვთ დაუკავშირდით CDC Screening-ის მხარდაჭერის ჯგუფს!</span>',
            showCancelButton: false,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'გასაგებია',
            heightAuto: false,
            keydownListenerCapture: true
          })
        }
        // BaseService.AddAMLParameter(this.header, param)
        //   .then(res => {
        //     if (res.data.success) {
        //       this.$swal({
        //         icon: 'success',
        //         title: 'ინცორმაცია!',
        //         html: '<span class="e-nusx-8 e-ts-09rem">მონაცემები დამახსოვრებულია!</span>',
        //         showCancelButton: false,
        //         confirmButtonColor: '#DD6B55',
        //         confirmButtonText: 'გასაგებია',
        //         heightAuto: false,
        //         keydownListenerCapture: true
        //       })
        //     }
        //   })
      }
    },
    clearForm () {
      this.individualErrorMsg = false
      this.juridicalErrorMsg = false
      BaseService.GetAMLParameters(this.header).then((res) => {
        if (res.data.success) {
          if (res.data.result.length > 0) {
            for (var i = 0; i < res.data.result.length; i++) {
              if (
                res.data.result[i].amlParameter.juridicalStatusId === 1 &&
                res.data.result[i].amlParameter.paramterTypeId === 3
              ) {
                this.BL_ParamsItem_PP = res.data.result[i]
              }
              if (
                res.data.result[i].amlParameter.juridicalStatusId === 2 &&
                res.data.result[i].amlParameter.paramterTypeId === 3
              ) {
                this.BL_ParamsItem_LE = res.data.result[i]
              }
            }
          }
          this.loading = false
        }
      })
    }
  }
}
</script>
